export default __webpack_public_path__ + "static/media/DHL-ALEMANIA-FRIDGE.41ea1893.svg";